import moment from "moment";
import { useEffect, useRef } from "react";

const useSyncInterval = callback => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    const now = moment();
    const next = moment(now)
      .add(5 - (now.minutes() % 5), "minutes")
      .seconds(1)
      .milliseconds(0);
    const delay = next.diff(now);
    const id = setInterval(tick, delay);
    return () => {
      clearInterval(id);
    };
  }, [callback]);
};

export default useSyncInterval;
